import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const PricingCard = ({
  icon: Icon,
  price,
  unitLabel,
  note,
  listTitle,
  items,
  bulletIcon: BulletIcon = CheckCircle,
  ctaLabel,
}) => (
  <Card className="border-2 border-blue-200">
    <CardContent className="p-8 space-y-6">
      <div className="flex items-center justify-between">
        <div className="bg-blue-100 rounded-full p-3">
          <Icon className="w-8 h-8 text-blue-600" />
        </div>
        <div className="text-right">
          <div className="text-4xl font-bold text-gray-900">${price.toFixed(2)}</div>
          <div className="text-gray-600">{unitLabel}</div>
        </div>
      </div>

      {note && <p className="text-sm text-gray-600 italic">{note}</p>}

      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">{listTitle}</h3>
        <ul className="space-y-3">
          {items.map((item) => (
            <li key={item} className="flex items-start space-x-3">
              <BulletIcon className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {ctaLabel && (
        <div className="pt-4">
          <Link to="/contact">
            <Button className="w-full bg-coral-500 hover:bg-coral-600 text-white">
              {ctaLabel}
            </Button>
          </Link>
        </div>
      )}
    </CardContent>
  </Card>
);

export default PricingCard;
